import React from 'react';
import './home.css';

export function HomeDiagram() {
    return (
        <div id="home_diagram_container" className="container">
            <div id="home_diagram" className='row'>
                <div className='home_diagram_step col-sm-12 col-md-4'>
                    <div id="step_title_01" className='step_title'>1. Configuration</div>
                    <div className="step_description_container">
                        <ul>
                            <li>Identify key social protection priorities</li>
                            <li>Collect information on demographic and financial context</li>
                            <li>Fill in:
                                <ul>
                                    <li>Population Groups (Current and objective)</li>
                                    <li>Benefits (Current and objective)</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='home_diagram_step col-sm-12 col-md-4'>
                    <div id="step_title_02" className='step_title'>2. Model Definition</div>
                    <div className="step_description_container">
                        <ul>
                            <li>Basic information setup</li>
                            <li>Economic and legal context</li>
                            <li>Benefit details</li>
                            <li>Population Groups details</li>
                            <li>Link population groups and benefits</li>
                            <li>Gap calculation and analysis</li>
                        </ul>
                    </div>
                </div>
                <div className='home_diagram_step col-sm-12 col-md-4'>
                    <div id="step_title_03" className='step_title'>3. Scenario</div>
                    <div className="step_description_container">
                        <b className="home_lbl_subt">Inputs</b>
                                <ul>
                                    <li>Historical demographic and financial inputs</li>
                                    <li>Projection period inputs</li>
                                </ul>
                        <b className="home_lbl_subt">Outputs</b>
                                <ul>
                                    <li>Demographic and financial projection outputs</li>
                                    <li>Summary charts</li>
                                </ul>                        
                    </div>
                </div>
            </div>
        </div>
    );
}
